module.exports = __webpack_public_path__ + "0aee3eeb128a693fc00b6f334045f024.svg";